import React from 'react';

import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { keys, pick } from 'lodash';
import { req } from 'react-reqq-lite';

import {
  Button,
  FormInput,
  FormInputSelect,
  FormInputTextArea,
} from 'modules/common/input';
import { removeEmpty, formatedSelectOption } from 'modules/common/utils';

import { INIT_FORM } from '../constants';
import { qrCodeSchema } from '../validations';
import { useCreateMenuBuilder, useUpdateMenuBuilder } from '../hooks';

function MenuBuilderModal({ branch, data, type, onClose }) {
  const [isCreateApiLoading, create] = useCreateMenuBuilder();
  const [isUpdateApiLoading, update] = useUpdateMenuBuilder();

  const { handleSubmit, values, setFieldValue, errors } = useFormik({
    validationSchema: qrCodeSchema,
    initialValues: {
      ...INIT_FORM,
      ...pick(data, keys(INIT_FORM)),
      branch_uuid: branch,
    },
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true,
    onSubmit: (payload) => {
      if (type === 'CREATE') {
        const $payload = branch
          ? {
              ...payload,
              branch_uuid: branch,
            }
          : payload;

        create($payload, () => {
          onClose();
        });
        return;
      }
      update(data?.uuid, payload, () => {
        onClose();
      });
    },
  });

  const onGetBranchOptions = async (input = '', cb) => {
    const args = {
      keyword: input,
      per_page: 50,
    };

    await req.get({
      key: 'GET_BRANCH_OPTIONS',
      url: '/v1/me/branches',
      params: removeEmpty(args),
      onSuccess: (res) => {
        const branch_list = res?.response?.data || [];
        const x = formatedSelectOption(
          branch_list,
          'attributes.uuid',
          'attributes.branch_name'
        );
        cb(x);
      },
    });
  };

  const { name = '', description = '', branch_uuid } = values;

  const isApiLoading = isCreateApiLoading || isUpdateApiLoading;

  return (
    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
      <div className="flex space-x-5">
        <div className="space-y-5 mr-auto w-full">
          <FormInput
            name="name"
            label="Name"
            autoFocus
            value={name || ''}
            onSetFieldValue={setFieldValue}
            error={errors?.name}
            required
          />
          {!branch && (
            <FormInputSelect
              label="Branch"
              placeholder="Select branch..."
              name="branch_uuid"
              required
              value={branch_uuid ?? ''}
              loadOptions={onGetBranchOptions}
              error={errors?.branch_uuid}
              onSetFieldValue={setFieldValue}
            />
          )}
          <FormInputTextArea
            name="description"
            label="Description"
            value={description || ''}
            onSetFieldValue={setFieldValue}
            error={errors?.description}
          />
          <div className="flex">
            <div className="ml-auto space-x-2">
              <Button
                className="btn md light w-28"
                label="Cancel"
                disabled={isApiLoading}
                onClick={onClose}
              />
              <Button
                className="btn md primary w-28"
                label={type === 'CREATE' ? 'Generate' : 'Update'}
                disabled={isApiLoading}
                isLoading={isApiLoading}
                type="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

MenuBuilderModal.defaultProps = {
  data: {},
  type: 'CREATE',
  branch: false,
};

MenuBuilderModal.propTypes = {
  type: PropTypes.string,
  data: PropTypes.instanceOf(Object),
  branch: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Object)]),
  onClose: PropTypes.instanceOf(Function).isRequired,
};

export default MenuBuilderModal;
